var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeather04D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "56px",
    viewBox: "0 0 58 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-04d") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-04d",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9167267,26.4173736 C43.0130099,26.7935021 42.0292015,27 41,27 C39.6164889,27 38.3150042,26.6268529 37.1798325,25.970113 C36.2567572,25.9026156 35.3623023,25.7220347 34.5081749,25.4410528 C33.3818323,28.6860415 30.4452474,31 27,31 C24.7527849,31 22.7219803,30.0155265 21.2687825,28.4303508 C20.4008786,28.7995415 19.4693901,29 18.5,29 C13.8055796,29 10,24.2989899 10,18.5 C10,12.9593118 13.4741098,8.42096814 17.8782442,8.02766251 C19.3457492,6.17629997 21.5435854,5 24,5 C25.3982721,5 26.712758,5.38115191 27.8564446,6.05100433 C29.98376,2.41424259 33.7316293,0 38,0 C42.9962607,0 47.27936,3.30785782 49.0850391,8.01229323 C49.2225281,8.00412901 49.3608737,8 49.5,8 C54.1944204,8 58,12.7010101 58,18.5 C58,24.2989899 54.1944204,29 49.5,29 C47.3630027,29 45.4101962,28.025829 43.9167267,26.4173736 Z",
    id: "Combined-Shape-Copy-7",
    stroke: "#59A5D8",
    fill: "#0A6EAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0885574,43.2250508 C38.9813618,43.7246595 37.7697731,44 36.5,44 C33.7612551,44 31.2931917,42.7190829 29.5594669,40.6697119 C28.3434233,44.9194912 24.7471959,48 20.5,48 C18.1205081,48 15.9453423,47.0330894 14.2785875,45.435362 C13.2430693,45.8022938 12.1418524,46 11,46 C4.92486775,46 0,40.4035594 0,33.5 C0,26.97846 4.39489765,21.6233784 10.0026752,21.0506844 C11.7410935,18.5854577 14.4530285,17 17.5,17 C18.8775954,17 20.1867053,17.3240867 21.3683221,17.9070413 C24.0355725,13.7525547 28.6963395,11 34,11 C40.5572201,11 46.1317261,15.2074992 48.1710151,21.0699949 C53.6955863,21.7343293 58,27.0459432 58,33.5 C58,40.4035594 53.0751322,46 47,46 C44.3818373,46 41.9773131,44.9605737 40.0885574,43.2250508 Z",
    id: "Combined-Shape-Copy-6",
    stroke: "#0A6EAC",
    fill: "#59A5D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeather04D);
export default __webpack_public_path__ + "static/media/icon-weather-04d.191192c2bd87ae6e6839d37fbad29fad.svg";
export { ForwardRef as ReactComponent };